module.exports = "/_next/static/images/2-959dd28745c4136b4a51616205a2bf68.jpg";